import PropTypes from 'prop-types';
import React, {createContext} from 'react';
import {AnyToDo} from '../../../../typings/todo';

export const SiteSettingsContext = createContext<AnyToDo>(null);

export class SiteSettingsProvider extends React.Component<any> {
  static propTypes = {
    siteSettings: PropTypes.any,
    children: PropTypes.element,
  };
  static childContextTypes = {
    siteSettings: PropTypes.any,
  };

  getChildContext() {
    return {siteSettings: this.props.siteSettings};
  }

  render() {
    return (
      <SiteSettingsContext.Provider value={this.props.siteSettings}>{this.props.children}</SiteSettingsContext.Provider>
    );
  }
}
